<template>
  <div>
    <v-layout wrap>
      <v-flex xs3 class="leftCell" pl-2>
        {{ $t('g') }}
      </v-flex>
      <v-flex xs9 pl-2>
        {{ experience.startDate }}
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-layout wrap>
      <v-flex xs3 class="leftCell" pl-2>
        {{ $t('h') }}
      </v-flex>
      <v-flex xs9 pl-2>
        {{ experience.endDate }}
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-layout wrap>
      <v-flex xs3 class="leftCell" pl-2>
        {{ $t('i') }}
      </v-flex>
      <v-flex xs9 pl-2>
        {{ experience.company }}
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-layout wrap>
      <v-flex xs3 class="leftCell" pl-2>
        {{ $t('j') }}
      </v-flex>
      <v-flex xs9 pl-2>
        {{ experience.title }}
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-layout wrap v-if="experience.description">
      <v-flex xs12 pl-2>
        <div><b>{{ $t('k') }}</b></div>
        <v-layout wrap>
          <v-flex xs12 class="quillAsHtmlContainer">
            <div class="quillAsHtml" v-html="experience.description"></div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout wrap v-else>
      <v-flex xs3 class="leftCell" pl-2>
        {{ $t('l') }}
      </v-flex>
    </v-layout>
    <v-divider/>
    <v-layout wrap>
      <v-flex xs3 class="leftCell" pl-2>
        {{ $t('m') }}
      </v-flex>
      <v-flex xs9 pl-2>
        {{ experience.technicalEnv }}
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    experience: Object
  }
}
</script>


<i18n>
{
  "fr": {
    "g": "Date de début",
    "h": "Date de fin",
    "i": "Entreprise",
    "j": "Titre",
    "k": "Description :",
    "l": "Description",
    "m": "Environnement technique"
  },
  "en": {
    "g": "Start date",
    "h": "End date",
    "i": "Company",
    "j": "Title",
    "k": "Description :",
    "l": "Description",
    "m": "Technical environment"
  }
}
</i18n>